import React from "react";
import { CalendarCheck, MessageCircle, Phone, ExternalLink, CheckCircle2 } from "lucide-react";
import { clinic, bookingSteps } from "../mock";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";

export default function ReservaModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl bg-[#e8f2fd] grid place-items-center text-[#1d6fc0] mb-1">
            <CalendarCheck size={22} />
          </div>
          <DialogTitle className="font-display text-xl text-[#0b2545]">
            Agenda tu cita médica online
          </DialogTitle>
          <DialogDescription>
            Reserva de forma segura en nuestra plataforma de gestión clínica.
          </DialogDescription>
        </DialogHeader>

        <ol className="space-y-3 mt-1">
          {bookingSteps.map((s, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="w-6 h-6 shrink-0 rounded-full bg-[#1d6fc0] text-white text-xs font-bold grid place-items-center mt-0.5">
                {i + 1}
              </span>
              <span className="text-sm text-slate-600 leading-relaxed">{s}</span>
            </li>
          ))}
        </ol>

        <a href={clinic.bookingUrl} target="_blank" rel="noopener noreferrer" className="block mt-2">
          <Button className="w-full rounded-full bg-[#1d6fc0] hover:bg-[#175a9e] h-11">
            Ir a reservar mi hora <ExternalLink size={16} className="ml-2" />
          </Button>
        </a>

        <div className="grid grid-cols-2 gap-2">
          <a href={clinic.whatsappLink} target="_blank" rel="noopener noreferrer">
            <Button variant="outline" className="w-full rounded-full h-10 border-slate-300 text-[#0b2545]">
              <MessageCircle size={16} className="mr-1.5 text-[#25D366]" /> WhatsApp
            </Button>
          </a>
          <a href={`tel:${clinic.callCenterTel}`}>
            <Button variant="outline" className="w-full rounded-full h-10 border-slate-300 text-[#0b2545]">
              <Phone size={16} className="mr-1.5 text-[#1d6fc0]" /> Llamar
            </Button>
          </a>
        </div>

        <div className="flex items-start gap-2 mt-1 rounded-xl bg-slate-50 border border-slate-100 p-3">
          <CheckCircle2 size={16} className="text-[#1d6fc0] shrink-0 mt-0.5" />
          <p className="text-xs text-slate-500 leading-relaxed">
            El proceso de reserva y registro se realiza de forma segura a través de una plataforma
            de gestión externa especializada. Tus datos personales y de salud se manejan con altos
            estándares de protección y confidencialidad.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
